import { html, LitElement, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_PATCH_MANAGEMENT_MAINTENANCE_WINDOW_SUMMARIES } from '../../../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { styles } from '../view/styles';
import { state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import { RootState, store } from '@nirvana/redux/store';
import { selectPoliciesState } from '../../../../../redux/slice';
import {
  getIsLoadingSummaryWindowState,
  getSelectedWindowIds,
} from '../../../../../redux/customStates/patchManagement/patch-management.actions';
import { PolicyPanelManager } from '../../../../../PolicyPanelManager';
import { PatchManagementSelectedMaintenanceWindow } from '../../../../../utils/uiSettings/patchManagement/patch-management.types';
import { GzMaintenanceWindowSummaryWebComponent } from '../../maintenanceWindowSummary';
import { MaintenanceWindowPreviewConverterV2 } from '../../utils/MaintenanceWindowSummaryConverterV2';

@customElement(WEB_COMPONENT_POLICY_PANEL_PATCH_MANAGEMENT_MAINTENANCE_WINDOW_SUMMARIES)
export class GzMaintenanceWindowSummariesWebComponent extends connect(store)(LitElement) {
  /**
   * Show/Hide loading spinner.
   */
  @state()
  private isLoading = false;

  /**
   * Re-render selected window ids.
   */
  @state()
  private selectedWindowIds: Array<string>;

  /**
   * Styles for the component.
   */
  static get styles() {
    return styles;
  }

  /**
   * State changed, update the component state.
   * @param rootState
   */
  public stateChanged(rootState: RootState) {
    const policiesApp = selectPoliciesState(rootState);

    this.selectedWindowIds = getSelectedWindowIds(policiesApp);
    this.isLoading = getIsLoadingSummaryWindowState(policiesApp);
  }

  /**
   * Render specific content.
   */
  protected render() {
    if (this.isLoading) {
      return this.renderLoadingContainer();
    }

    return html` <div class="products-section d-flex flex-column">${this.renderSummaries()}</div> `;
  }

  /**
   * Render loading container.
   */
  private renderLoadingContainer(): TemplateResult {
    return html` <div class="loading-container">
      <gz-progress-spinner size="large"></gz-progress-spinner>
    </div>`;
  }

  /**
   * Render error state.
   */
  private renderErrorState(): TemplateResult {
    return html`
      <gz-image-repo state="error"
        ><gz-text fontweight="400" fontsize="13"> ${translateFn('Could not load maintenance window details')} </gz-text>
      </gz-image-repo>
    `;
  }

  /**
   * Render summaries.
   */
  private renderSummaries(): TemplateResult[] {
    const previewConverter = new MaintenanceWindowPreviewConverterV2();
    previewConverter.injectDependencies({
      translateFn: translateFn,
    });

    return this.selectedWindowIds.map(windowId => {
      // get from manager
      const window: PatchManagementSelectedMaintenanceWindow | undefined =
        PolicyPanelManager.getInstance().getCachedPatchManagementSelectedMaintenanceWindowPolicyInfo(windowId);

      // render error state if window is not found
      if (!window) {
        return this.renderErrorState();
      }

      // create summary component
      const summaryData = previewConverter.convertToTemplateDataV2(window);
      const summaryComponent = new GzMaintenanceWindowSummaryWebComponent();
      summaryComponent.summaryData = summaryData;

      return html` ${summaryComponent}`;
    });
  }
}
